import React from "react";
import { Container } from "../components/general/universal/Container";
import { GoogleAccountEditComponent } from "../components/login/GoogleAccountEditComponent";

const AccountEdit = () => {
	return (
		<Container>
			<GoogleAccountEditComponent />
		</Container>
	);
};

export default AccountEdit;
